import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { CameraServerService } from '../../camera-server.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConstants, DEVICE_TYPE_LIST, ErrorMessageFormField } from 'src/app/shared/app-constants';

@Component({
  selector: 'app-device-details-dialog',
  templateUrl: './device-details-dialog.component.html',
  styleUrls: ['./device-details-dialog.component.scss']
,
  standalone: false
})
export class DeviceDetailsDialogComponent implements OnInit {
  potentialId: string = '';
  deviceTypsData: any = DEVICE_TYPE_LIST;
  deviceInputForm: FormGroup = new FormGroup({});
  isAddButton: boolean = false;
  loading: boolean = false;
  isAddedData: boolean = false;
  isSecondaryIpAddress: boolean = false;
  headerName: string = "";
  errorMessageFormField: any = ErrorMessageFormField;

  editableDeviceData: any = {};
  hidePassword: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DeviceDetailsDialogComponent>,
    private camService: CameraServerService,
    private toastr: ToastrService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.deviceInputForm = this.formBuilder.group({
      ipAddress: ['', [Validators.required]],
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
      uniqueID: [''],
      macAddress: ['', [Validators.required]],
      deviceName: ['', [Validators.required]],
      deviceType: ['Switches', [Validators.required]],
      portNumber: [0, [Validators.required]],
      secondaryIpAddress: [null],
    })
    const isAddOutputs = sessionStorage.getItem("isAddOutputs");
    if (isAddOutputs === 'true') {
      this.isAddButton = true;
      this.headerName = "Add Device";
    } else {
      this.isAddButton = false;
      this.headerName = `Edit Device ${this.data?.deviceUniqueId}`;
      this.getDeviceByDeviceUniqueId(this.data && this.data?.deviceUniqueId);
    }
    this.potentialId = sessionStorage.getItem("potentialId");
    this.handleSelectDeviceType("Switches");
  }

  /** Check validation while adding the device all field filled or not */
  isAddValidation() {
    if (this.deviceInputForm.value.ip !== '' && this.deviceInputForm.value.username !== '' &&
      this.deviceInputForm.value.password !== '' && this.deviceInputForm.value.macAddress !== '' &&
      this.deviceInputForm.value.deviceName !== '' && this.deviceInputForm.value.deviceType !== '' && this.deviceInputForm.value.portNumber) {
      return true;
    } else {
      return false;
    }
  }

  handleSelectDeviceType(event: any) {
    if (event === 'Router') {
      this.isSecondaryIpAddress = true;
    } else {
      this.isSecondaryIpAddress = false;
    }

    if (this.deviceInputForm.value.deviceType === "Switches") {
      this.deviceInputForm.controls['deviceName']?.setValue('Switch');
      this.deviceInputForm.controls['username']?.setValue('admin');
      this.deviceInputForm.controls['password']?.setValue('');
      this.deviceInputForm.controls['portNumber']?.setValue(4001);
    } else if (this.deviceInputForm.value.deviceType === "Router") {
      this.deviceInputForm.controls['deviceName']?.setValue('Router');
      this.deviceInputForm.controls['username']?.setValue('admin');
      this.deviceInputForm.controls['password']?.setValue('4710247c');
      this.deviceInputForm.controls['portNumber']?.setValue(null);
    } else if (this.deviceInputForm.value.deviceType === "Access points") {
      this.deviceInputForm.controls['deviceName']?.setValue('AccessPoint');
      this.deviceInputForm.controls['username']?.setValue('admin');
      this.deviceInputForm.controls['password']?.setValue('');
      this.deviceInputForm.controls['portNumber']?.setValue(null);
    } else if (this.deviceInputForm.value.deviceType === "Client Bridges") {
      this.deviceInputForm.controls['deviceName']?.setValue('ClientBridge');
      this.deviceInputForm.controls['username']?.setValue('admin');
      this.deviceInputForm.controls['password']?.setValue('');
      this.deviceInputForm.controls['portNumber']?.setValue(null);
    } else if (this.deviceInputForm.value.deviceType === "NAS") {
      this.deviceInputForm.controls['deviceName']?.setValue('NAS');
      this.deviceInputForm.controls['username']?.setValue('admin');
      this.deviceInputForm.controls['password']?.setValue('');
      this.deviceInputForm.controls['portNumber']?.setValue(5001);
    } else if (this.deviceInputForm.value.deviceType === "Odroid") {
      this.deviceInputForm.controls['deviceName']?.setValue('Odroid');
      this.deviceInputForm.controls['username']?.setValue('pro-vigil');
      this.deviceInputForm.controls['password']?.setValue('247Supp0rt');
      this.deviceInputForm.controls['portNumber']?.setValue(22);
    } else {
      this.deviceInputForm.controls['deviceName']?.setValue('');
      this.deviceInputForm.controls['username']?.setValue('root');
      this.deviceInputForm.controls['portNumber']?.setValue(0);
      this.deviceInputForm.controls['password']?.setValue(null);
    }
  }

  /** This methods is used for adding devices */
  addDevice() {
    const payloads: any = {
      potentialId: this.potentialId,
      ip: this.deviceInputForm.value.ipAddress,
      username: this.deviceInputForm.value.username,
      password: this.deviceInputForm.value.password,
      macAddress: this.deviceInputForm.value.macAddress,
      deviceName: this.deviceInputForm.value.deviceName,
      deviceType: this.deviceInputForm.value.deviceType,
      secondaryIpAddress: this.deviceInputForm.value.secondaryIpAddress,
      portno: parseInt(this.deviceInputForm.value.portNumber),

    }
    if (this.deviceInputForm.valid) {
      this.spinner.activate();
      this.loading = true;
      this.camService.addDevices(payloads, "OTHER_DEVICE_DATA").subscribe((response: any) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.success(response?.data?.message || "Device data is saved successfully.");
          this.dialogRef.close();
          this.isAddedData = true;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning("Please try after some times");
          this.isAddedData = false;
        }
      }, (err) => {
        if (err) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    } else {
      this.isAddedData = false;
      this.toastr.error(AppConstants.mandatoryFieldMsg);
    }
  }

  /** This methods is used for getting devices by unique ID */
  getDeviceByDeviceUniqueId(deviceUniqueId: string) {
    this.spinner.activate();
    this.loading = true;
    if (deviceUniqueId) {
      this.camService.getDeviceByDeviceUID(deviceUniqueId).subscribe((response: any) => {
        if (response && response.success) {
          this.editableDeviceData = response?.data;
          if (response?.data?.device?.otherDeviceData?.deviceType === 'Router') {
            this.isSecondaryIpAddress = true;
          } else {
            this.isSecondaryIpAddress = false;
          }
          this.deviceInputForm = this.formBuilder.group({
            ipAddress: response?.data?.device?.otherDeviceData?.ip,
            username: response?.data?.device?.otherDeviceData?.username,
            password: response?.data?.device?.otherDeviceData?.password,
            uniqueID: response?.data?.device?.deviceUniqueId,
            macAddress: response?.data?.device?.otherDeviceData?.macAddress,
            deviceName: response?.data?.device?.otherDeviceData?.deviceName,
            deviceType: response?.data?.device?.otherDeviceData?.deviceType,
            portNumber: response?.data?.device?.otherDeviceData?.portno,
            secondaryIpAddress: response?.data?.device?.otherDeviceData?.secondaryIpAddress,
          })
          this.potentialId = response?.data?.device?.potentialId;
          this.spinner.deactivate();
          this.loading = false;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  /** This methods is used for Updating the device*/
  updateDevice() {
    const payloads: any = {
      deviceUniqueId: this.data?.deviceUniqueId,
      potentialId: this.data?.potentialId,
      ip: this.deviceInputForm.value.ipAddress,
      username: this.deviceInputForm.value.username,
      password: this.deviceInputForm.value.password,
      macAddress: this.deviceInputForm.value.macAddress,
      deviceName: this.deviceInputForm.value.deviceName,
      deviceType: this.deviceInputForm.value.deviceType,
      secondaryIpAddress: this.deviceInputForm.value.secondaryIpAddress,
      portno: parseInt(this.deviceInputForm.value.portNumber),
    }
    if (this.isAddValidation()) {
      this.spinner.activate();
      this.loading = true;
      this.camService.updateDevices(payloads, "OTHER_DEVICE_DATA").subscribe((response: any) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.success(response?.data?.message || "Device data is updated successfully.");
          this.dialogRef.close();
          // this.isAddedData = true;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning("Please try after some times");
          // this.isAddedData = false;
        }
      }, (err) => {
        if (err) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    } else {
      // this.isAddedData = false;
      this.toastr.error(AppConstants.mandatoryFieldMsg);
    }
  }

}
